import { useTranslation } from "react-i18next";
import { Grid, Row, Col } from "rsuite";
import ShortCutPanel, { types } from "../components/ShortcutPanel";
import TableIcon from "@rsuite/icons/legacy/Table";
import { Icon } from "@rsuite/icons";
import { SlLockOpen } from "react-icons/sl";

const ReportsShortcuts = () => {
  const [t] = useTranslation();

  return (
    <Grid fluid>
      <Row>
        <Col xs={24} sm={24} lg={12}>
          <ShortCutPanel
            type={types.warning}
            title={t("main-sidebar.devices")}
            paragraph={t("main-sidebar.reports")}
            href={"/reports/devices/all"}
            icon={<TableIcon />}
            className={"content-init"}
          />
        </Col>
        <Col xs={24} sm={24} lg={12}>
          <ShortCutPanel
            type={types.warning}
            title={t("main-sidebar.users")}
            paragraph={t("main-sidebar.reports")}
            href={"/reports/users/access"}
            icon={<Icon as={SlLockOpen} />}
            className={"content-end"}
          />
        </Col>
      </Row>
    </Grid>
  );
};

export default ReportsShortcuts;
